import React from "react";

export default function ReferIconNew() {
  return (
    <svg
      width="19"
      height="15"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7283 3.55805C14.7283 5.05996 13.5271 6.26747 12.0296 6.26747C11.9697 6.26747 11.9104 6.26554 11.8516 6.26178C12.2725 5.45463 12.5189 4.54329 12.5189 3.55805C12.5189 2.5786 12.2818 1.66149 11.8579 0.853923C11.9146 0.850425 11.9719 0.848633 12.0296 0.848633C13.5271 0.848633 14.7283 2.05613 14.7283 3.55805ZM9.37927 3.55805C9.37927 5.05996 8.17811 6.26747 6.68055 6.26747C5.18082 6.26747 3.97114 5.05778 3.97114 3.55805C3.97114 2.05831 5.18082 0.848633 6.68055 0.848633C8.17811 0.848633 9.37927 2.05613 9.37927 3.55805ZM15.739 12.1165C15.739 11.279 15.5095 10.5488 15.127 9.91686C15.6843 10.0886 16.2157 10.3025 16.6671 10.5559C17.5293 11.0401 17.9484 11.5766 17.9484 12.1165V13.7561H15.739V12.1165ZM0.761719 12.1165C0.761719 11.765 0.933449 11.4208 1.30292 11.0798C1.6759 10.7355 2.2164 10.4289 2.85448 10.1737C4.1314 9.6629 5.67297 9.40708 6.68055 9.40708C7.68813 9.40708 9.2297 9.6629 10.5066 10.1737C11.1447 10.4289 11.6852 10.7355 12.0582 11.0798C12.4277 11.4208 12.5994 11.765 12.5994 12.1165V13.7561H0.761719V12.1165Z"
        stroke="white"
      />
    </svg>
  );
}
